import {
  components,
} from '@/generated/qmulus/openapi.ts';

const maintenanceRecurrencePeriod: Record<NonNullable<components['schemas']['MaintenanceSeriesCreate']['recurrence']['period']>, string> = {
  never: 'Nikdy',
  week: 'Týždne',
  month: 'Mesiace',
  year: 'Roky',
};

export default {
  title: 'Opakovanie',
  repeat: 'Opakovať',
  every: 'Každý',
  on: 'V',
  end: 'Koniec',
  maintenanceRecurrencePeriod,
  selectMonths: 'Vybrať mesiace',
};
